import type { AnnotatorsState } from './annotators.types';

export const ANNOTATORS_INITIAL_STATE: AnnotatorsState = {
  annotators: {
    data: [],
    loading: 'idle',
    error: { name: '', message: '' },
  },
  targets: {
    data: [],
    loading: 'idle',
    error: { name: '', message: '' },
  },
  presets: {
    data: [],
    loading: 'idle',
    error: { name: '', message: '' },
  },
  jobs: {
    data: [],
    loading: 'idle',
    error: { name: '', message: '' },
  },
};

export const ANNOTATORS_FETCHING_ERROR_PREFIX = 'Failed to fetch annotators';
export const TARGETS_FETCHING_ERROR_PREFIX = 'Failed to fetch annotator targets';
export const PRESETS_FETCHING_ERROR_PREFIX = 'Failed to fetch annotator presets';
export const PRESET_CREATE_ERROR_PREFIX = 'Failed to create annotator preset';
export const PRESET_UPDATE_ERROR_PREFIX = 'Failed to update annotator preset';
export const PRESET_DELETE_ERROR_PREFIX = 'Failed to delete annotator preset';
export const JOBS_FETCHING_ERROR_PREFIX = 'Failed to fetch annotation jobs';
export const ANNOTATE_PROJECT_ERROR_PREFIX = 'Failed to start annotation';
export const CANCEL_JOB_ERROR_PREFIX = 'Failed to cancel job';
export const JOB_TYPE_NEW_ANNOTATE_PROJECT = 'NEW_ANNOTATE_PROJECT';
